<template>
  <div
    :class="[
      'slide-info flex-column',
      {
        white,
        'align-start': align == 'left',
        'align-center': align == 'center',
        'align-end': align == 'right',
      },
    ]"
  >
    <div v-if="title" class="title-block flex-column">
      <div
        v-for="(item, index) of title.split('#')"
        :key="index"
        class="title info-label"
      >
        {{ item }}
        <img
          v-if="index == title.split('#').length - 1"
          class="dot"
          src="~@/assets/images/home_pic2_title@2x.png"
        />
      </div>
    </div>
    <div v-if="subtitle" class="subtitle info-label">{{ subtitle }}</div>
    <div v-if="divider" class="divider info-label">/</div>
    <div
      v-if="desc"
      class="desc-block flex-column"
      :style="{ width: `${width}vw` }"
    >
      <div
        v-for="(item, index) of desc.split('#')"
        :key="index"
        class="desc info-label"
      >
        {{ item }}
      </div>
    </div>
    <button
      v-if="buttonText"
      :class="[
        'button flex-row justify-between align-center',
        { simple: buttonType == 'simple' },
      ]"
      :style="{ width: `${width}vw` }"
    >
      <span class="text info-label">{{ buttonText }}</span>
      <mpPopover>
        <img
          draggable="false"
          class="icon"
          src="~@/assets/images/home_pic2_next@2x.png"
        />
      </mpPopover>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import mpPopover from "../../../../components/mp-popover/mp-popover.vue";

export default defineComponent({
  components: { mpPopover },

  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    desc: {
      type: String
    },
    divider: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String
    },
    buttonType: {
      type: String,
      default: 'default'
    },
    width: {
      type: Number,
      default: 20.36
    },
    align: {
      type: String,
      default: 'left'
    },
    white: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="less" scoped>
.slide-info {
  z-index: 1;
  
  .title-block {
    justify-content: inherit;
    align-items: inherit;

    .title {
      position: relative;
      width: fit-content;
      font-size: 1.82vw;
      line-height: 2.5vw;
      color: #303030;
      font-family: @font-ab;

      .dot {
        width: 0.94vw;
        height: auto;
        position: absolute;
        right: 0;
        bottom: 0.36vw;
        transform: translateX(calc(0.52vw + 100%));
      }
    }

    & + .subtitle {
      margin-top: 2.6vw;
    }

    & + .divider {
      margin-top: 1.56vw;
    }

    & + .desc-block {
      margin-top: 0.52vw;
    }

    & + .button {
      margin-top: 0;
    }
  }

  .subtitle {
    font-size: 1.3vw;
    line-height: 1.77vw;
    font-family: @font-ab;

    & + .divider {
      margin-top: 1.56vw;
    }
  }

  .divider {
    font-size: 1.04vw;
    line-height: 1.41vw;
    color: #767676;

    & + .desc-block {
      margin-top: 1.56vw;
    }
  }

  .desc-block {
    justify-content: inherit;
    align-items: inherit;

    & + .button {
      margin-top: 2.08vw;
    }

    .desc {
      font-size: 0.78vw;
      line-height: 1.56vw;
      text-align: justify;
      color: #a0a0a0;
    }
  }

  .button {
    @hr: 4.48vw;
    @border:solid rgba(160, 160, 160, 0.3) 1px;
    height: @hr;
    border-top: @border;
    border-bottom: @border;

    .text {
      position: relative;
      font-size: 1.04vw;
      color: #303030;
      line-height: @hr;
      font-family: @font-am;
    }

    .icon {
      width: 1.3vw;
      height: auto;
    }

    &.simple {
      width: auto !important;
      border-top: none;
      border-bottom: none;

      .text {
        margin-right: 0.52vw;
        padding-bottom: 0.5vw;

        &::after {
          content: "";
          width: 100%;
          height: 1px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(0.5vw);
          background-color: #303030;
        }
      }
    }
  }

  &.white {
    .info-label {
      color: white;
    }

    .dot{
      filter: brightness(500%);
    }
  }
}
</style>